/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var Site = /** @class */ (function () {
        function Site() {
        }
        Site.init = function () {
            Site.run();
        };
        Site.run = function () {
            Site.initResponsiveTables();
            Site.initMeetingBoxes();
            Site.initFrontpage();
            Site.initFormbuilder();
        };
        Site.is = function (bodyClass) {
            return document.body.classList.contains(bodyClass);
        };
        Site.initResponsiveTables = function () {
            var tables = document.querySelectorAll('body:not(.admin) main table');
            Array.prototype.forEach.call(tables, function (el) {
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('table-responsive');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
            });
        };
        Site.initMeetingBoxes = function () {
            var boxes = document.querySelectorAll('#meetingBoxes .boxTitle');
            for (var _i = 0, _a = Array.from(boxes); _i < _a.length; _i++) {
                var box = _a[_i];
                box.addEventListener('click', function (event) {
                    event.preventDefault();
                    var thisBox = event.currentTarget;
                    var boxContainer = thisBox.parentNode;
                    var open = boxContainer.classList.contains('open');
                    Array.from(document.querySelectorAll('.box'))
                        .forEach(function (b) { return b.classList.remove('open'); });
                    if (!open) {
                        boxContainer.classList.toggle('open');
                    }
                });
            }
        };
        Site.initFrontpage = function () {
            if (!Site.is('frontpage')) {
                return;
            }
            Site.initTabs();
        };
        Site.initFormbuilder = function () {
            if (!Site.is('formbuilder')) {
                return;
            }
            var file = document.querySelector('#file');
            if (!file) {
                return;
            }
            file.addEventListener('change', function (e) {
                var span = file.closest('span');
                if (file.value) {
                    var filename = file.value.replace(/C:\\fakepath\\/i, '');
                    span.dataset.filename = filename.length > 20
                        ? filename.substr(0, 12) + '...' + filename.substr(filename.length - 12, filename.length)
                        : filename;
                }
                else {
                    span.removeAttribute('data-filename');
                }
            });
        };
        Site.initTabs = function () {
            var tabsWrapper = document.querySelectorAll('.tabs__wrapper');
            Array.prototype.forEach.call(tabsWrapper, function (wrapper) {
                wrapper.querySelector('.tabs__nav').querySelectorAll('button').forEach(function (button) {
                    button.addEventListener('click', function () {
                        wrapper.querySelectorAll('.active').forEach(function (active) {
                            active.classList.remove('active');
                        });
                        button.classList.add('active');
                        var key = button.dataset.tab;
                        wrapper.querySelector(".tab[data-tab=" + key + "]").classList.add('active');
                    });
                });
            });
        };
        return Site;
    }());
    Site.init();

    exports.Site = Site;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
